/**
 * Action id constants for the content header's more actions menu.
 */

export const ACTION_MOVE_CONTENT = 'action-move-page-dialog-link';
export const ACTION_MOVE_BLOGPOST = 'action-move-blogpost-dialog-link';
export const ACTION_REMOVE_CONTENT = 'action-remove-content-link';
export const ACTION_COPY_CONTENT = 'action-copy-page-link';
export const ACTION_ARCHIVE_CONTENT = 'action-archive-link';
export const ACTIONS_RESTORE_CONTENT = 'action-restore-link';

export const ACTION_GIVE_FEEDBACK = 'action-give-feedback-link';
export const ACTION_VIEW_RESOLVED_COMMENTS = 'view-resolved-comments';
export const ACTION_VIEW_VERSION_HISTORY = 'action-view-version-history-link';
export const ACTION_VIEW_PAGE_HISTORY = 'action-view-history-link';
export const ACTION_EXPORT_PDF = 'action-export-pdf-link';
export const ACTION_EXPORT_WORD = 'action-export-word-link';
export const ACTION_EXPORT_MARKDOWN = 'action-export-markdown-link';
export const ACTION_TEMPLATES_AND_IMPORT = 'action-templates-and-import';
export const ACTION_TEMPLATES = 'action-templates';
export const ACTION_IMPORT = 'action-import';
export const ACTION_CONVERT_TO_BLOG = 'action-convert-page-to-blog';
export const ACTION_CONVERT_TO_FOLDER = 'action-convert-page-to-folder';
export const ACTION_CONVERT_TO_PAGE = 'action-convert-live-doc-to-page';
export const ACTION_CONVERT_TO_MARKDOWN = 'action-convert-page-to-markdown';
export const ACTION_CONVERT_TO_RICH_TEXT = 'action-convert-page-to-rich-text';

export const ACTION_WHITEBOARD_PREFERENCES = 'preferences';
export const ACTION_WHITEBOARD_EXPORT = 'export-file';
export const ACTION_WHITEBOARD_FIND_REPLACE = 'open-find-replace';
export const ACTION_WHITEBOARD_IMPORT = 'whiteboard-import';
export const ACTION_PRESENT_CONTENT = 'presentation-mode';
export const SWITCH_TO_LIVE_EDIT_WEB_ITEM = 'action-switch-to-live-edit';
export const ACTION_REVERT = 'action-revert-to-previous';
export const ACTION_REVERT_TO_LEGACY_EDITOR = 'action-revert-editor';
export const ACTION_WHITEBOARD_FULLSCREEN = 'fullscreen';
export const ACTION_WHITEBOARD_DOCUMENTATION = 'whiteboard-documentation';
export const ACTION_WHITEBOARD_TEMPLATES = 'whiteboard-templates';
export const ACTION_WHITEBOARD_TO_LIVE_DOC_WITH_ROVO = 'whiteboard-to-live-doc-with-rovo';

export const ACTION_FAVOURITE_CONTENT = 'action-favourite-content';
export const ACTION_FAVOURITE_SPACE = 'action-favourite-space';
export const ACTION_WATCH_CONTENT = 'action-watch-content';
export const ACTION_SMART_FOLDER_SYNC = 'action-smart-folder-sync';
export const ACTION_ASK_TO_EDIT_CONTENT = 'ask-to-edit-content';
export const ACTION_PREVIEW_CONTENT = 'action-preview-content';
export const ACTION_MANAGE_CONTENT = 'action-manage-content';
export const ACTION_AUTOMATIONS = 'action-automations';
export const ACTION_ADVANCED = 'action-advanced';
export const ACTION_VIEW_STORAGE_FORMAT = 'action-view-storage-link';
export const ACTION_VIEW_SOURCE = 'action-view-source-link';

export const ACTION_DATABASE_COPY_STRUCTURE = 'databases-copy-structure';
export const ACTION_DATABASE_UNDO = 'databases-undo';
export const ACTION_DATABASE_REDO = 'databases-redo';
export const ACTION_DATABASE_TEMPLATES = 'databases-templates';
export const ACTION_DATABASE_EXPORT = 'databases-export';
export const ACTION_DATABASE_LOCK_STRUCTURE = 'databases-lock-structure';
export const ACTION_DATABASE_GET_HELP = 'databases-get-help';
export const ACTION_DATABASE_DEVTOOLS = 'databases-devtools';

export const ACTION_EMBED_REPLACE_LINK = 'action-edit-embed-link';
export const ACTION_PAGES_PERMISSIONS_LINK = 'action-page-permissions-link';
export const ACTION_EXPORT_CONTENT = 'action-export-content';
export const ACTION_SLIDES_EXPORT_PDF = 'slides-export-to-pdf';
export const ACTION_CONVERT_CONTENT = 'action-convert-content';
export const ACTION_COMPANY_HUB_FEEDBACK = 'action-company-hub-feedback';
export const ACTION_EDITOR_UNDO = 'action-editor-undo';
export const ACTION_EDITOR_REDO = 'action-editor-redo';
export const ACTION_EDITOR_FIND_REPLACE = 'action-editor-find-replace';
export const ACTION_REPORT_ABUSE = 'action-report-abuse';
